export const VIDEO_VARIANTS = Object.freeze({
	VARIANT_1: 'video-1',
	VARIANT_2: 'video-2',
	VARIANT_3: 'video-3',
	VARIANT_4: 'video-4',
	VARIANT_5: 'video-5',
	VARIANT_6: 'video-6',
	VARIANT_7: 'video-7',
	VARIANT_8: 'video-8',
	VARIANT_9: 'video-9',
})
